import { gql } from "@apollo/client";

export default gql`
  mutation removeReadAiIntegrationMutation {
    removeReadAiIntegration {
      user {
        id
        hasReadAiAuth
      }
    }
  }
`;
